import React, { useState } from "react";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

const LineGraph = ({ dataset1, dataset2 }) => {
  const [hoverData, setHoverData] = useState(null);
  const [activeLines, setActiveLines] = useState([]);

  const handleHover = (data) => {
    if (data && data.isTooltipActive) {
      const activeLines = [];
      data.activePayload.forEach((_) => {
        if (_ && _.payload.value !== null) {
          activeLines.push({ name: _.name, payload: _.payload });
        }
      });
      setActiveLines(activeLines);
      setHoverData(data);
    } else {
      setActiveLines([]);
      setHoverData(null);
    }
  };

  const getTooltipData = () => {
    if (hoverData && hoverData.isTooltipActive) {
      const data = hoverData.activePayload[0].payload;
      const date = new Date(data.timestamp).toLocaleString();
      const values = activeLines.map((line) => ({
        name: line.name,
        timestamp: line.payload.timestamp,
        value: line.payload.value,
      }));
      return {
        date,
        values,
      };
    }
    return null;
  };

  return (
    <div>
      <LineChart width={500} height={500} onMouseMove={handleHover}>
        <CartesianGrid stroke="#ccc" />
        <XAxis dataKey="timestamp" />
        <YAxis />
        <Tooltip content={<CustomTooltip data={getTooltipData()} />} />
        <Line
          type="monotone"
          data={dataset1}
          dataKey="value"
          stroke="#8884d8"
          name="dataset1"
        />
        <Line
          type="monotone"
          data={dataset2}
          dataKey="value"
          stroke="#82ca9d"
          name="dataset2"
        />
      </LineChart>
    </div>
  );
};

const CustomTooltip = ({ data }) => {
  if (data) {
    return (
      <div
        style={{
          backgroundColor: "white",
          border: "1px solid black",
          padding: "5px",
        }}
      >
        <p>Date: {data.date}</p>
        {data.values.map((item) => (
          <p key={item.name}>
            {item.name} - {item.timestamp}: {item.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default LineGraph;
